<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle, } from '@headlessui/vue'
import { AnswerResultType } from '../../types/assessment';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';

import { audioManager } from '../../utils/audioManager';
import quizAnswerCorrected from '../../assets/audios/quiz_answer_corrected.wav'
import quizAnswerAlmost from '../../assets/audios/quiz_answer_almost.wav'
import quizAnswerIncorrected from '../../assets/audios/quiz_answer_incorrected.wav'
import { QuizAudioKey } from '../../types/quiz';
import FloattingEffect from '../Animation/FloattingEffect.vue';

const { t } = useI18n()

const props = defineProps<{
    point: number
    type: AnswerResultType
}>()

const isOpen = ref<boolean>(true)

const style = computed<string>(() => {
    switch (props.type) {
        case AnswerResultType.INCORRECT:
            return 'red-500'
        case AnswerResultType.CORRECT:
            return 'lime-500'
        case AnswerResultType.ALMOST_CORRECT:
            return 'yellow-500'
        default:
            return ''
    }
})

onMounted(() => {
    if (props.type === AnswerResultType.CORRECT) {
        audioManager.play(quizAnswerCorrected, QuizAudioKey.SFX)
        return
    }
    if (props.type === AnswerResultType.ALMOST_CORRECT) {
        audioManager.play(quizAnswerAlmost, QuizAudioKey.SFX)
        return
    }
    if (props.type === AnswerResultType.INCORRECT) {
        audioManager.play(quizAnswerIncorrected, QuizAudioKey.SFX)
        return
    }
})

</script>
<template>
    <TransitionRoot appear :show="isOpen" as="template">
        <Dialog as="div" class="relative z-20">
            <TransitionChild as="div" class="fixed inset-0 bg-black/60" enter="duration-300 ease-out"
                enter-from="opacity-0" enter-to="opacity-100" leave="duration-200 ease-in" leave-from="opacity-100"
                leave-to="opacity-0">
                <FloattingEffect :type="props.type" />
            </TransitionChild>
            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="w-full max-w-xs transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                            <DialogTitle as="h3" class="text-lg leading-5 p-3 text-center text-white font-bold"
                                :class="`bg-${style}`">
                                {{ t(TEXT[props.type]) }}
                            </DialogTitle>
                            <div class="p-10">
                                <p class="leading-10 font-bold text-center text-4xl" :class="`text-${style}`">{{
                                    `+${props.point} pts` }}</p>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>